/* src/app/components/submission-model-indentification-classification-eu/submission-model-indentification-classification-eu.component.css */
/*# sourceMappingURL=submission-model-indentification-classification-eu.component.css.map */
